type ConstValuesType = {
    magiaOgrodowCookieRodo: string,
    magiaOgrodowCookieRodoValue: string
}

const ConstValues: ConstValuesType = {
    magiaOgrodowCookieRodo:'magiaOgrodowCookieRodo',
    magiaOgrodowCookieRodoValue:'RodoHasBeenAccepted'
}

export default ConstValues;